import { adsPurple } from "../utils/ADSColours";

const ESUClassification = [
  {
    id: 4,
    osText: "Pedestrian way or footpath",
    colour: adsPurple,
  },
  {
    id: 6,
    osText: "Cycle track",
    colour: adsPurple,
  },
  {
    id: 8,
    osText: "Open to vehicles",
    colour: adsPurple,
  },
  {
    id: 11,
    osText: "Motorway",
    colour: adsPurple,
  },
  {
    id: 12,
    osText: "Special road",
    colour: adsPurple,
  },
  {
    id: 13,
    osText: "Car park",
    colour: adsPurple,
  },
];

export default ESUClassification;
